<template>
    <v-card outlined elevation="0" class="rounded v-application">
        <v-card-title>Organisatorisches</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5 pb-1">
            <p v-if="pharmacy.parking">
                <strong>Parkplatz: </strong>{{ pharmacy.pretty_parking }}
            </p>

            <p v-if="pharmacy.public_transport">
                <strong>ÖPNV: </strong>
                <span v-if="pharmacy.public_transport.closest_stop">
                    Nächste Haltestelle: {{ pharmacy.public_transport['closest_stop'] }}
                </span>
                <span v-if="pharmacy.public_transport.distance_to_train_station">
                        Entfernung zum nächsten Hbf: {{ pharmacy.public_transport['distance_to_train_station'] }}
                </span>
            </p>

            <p v-if="pharmacy.clothing">
                <strong>Kleidung: </strong>{{ pharmacy.pretty_clothing }}
                <span v-if="pharmacy.clothing == '1'">
                    {{pharmacy.clothing_color}}
                </span>
            </p>

            <p v-if="pharmacy.surroundings">
                <strong>APO-Typ: </strong>{{ pharmacy.pretty_surroundings }}
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        pharmacy: Object
    },
}
</script>

<style></style>